export default "__VITE_ASSET__Cs777ucg__"